module.exports = {"230671010":"开发区黎明街道","230671580":"高新区农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230671.json
// module id = 829
// module chunks = 0